import format from 'date-fns/format';
import isAfter from 'date-fns/isAfter';

import {
  COMPLETE,
  DUE,
  INSTANCE_COLOR_MAP,
  UPCOMING,
} from '../Constants/GatewayReminderInstances';

export function generateCalendarTypeProps(instance, now, isOrgReport = false) {
  const {
    GtemplateReminder: { recurring },
    MaintenanceHistoryLogs,
    MaintenanceNotifications,
    next_time_due,
    next_time_upcoming,
  } = instance;

  const calendar_start = new Date(next_time_upcoming).getTime(),
    calendar_end = new Date(next_time_due).getTime(),
    isCompletedOneTimeReminder = isOrgReport
      ? !recurring && !!MaintenanceNotifications?.MaintenanceHistoryLog?._id
      : !recurring && !!MaintenanceHistoryLogs?.length,
    calendar_percentage = isCompletedOneTimeReminder
      ? 1
      : (now - calendar_start) / (calendar_end - calendar_start),
    calendar_upcoming_epoch = new Date(next_time_upcoming).getTime(),
    calendar_upcoming = format(calendar_upcoming_epoch, 'LLLL do, y');

  const status = isAfter(now, calendar_end)
      ? DUE
      : isAfter(now, calendar_start)
        ? UPCOMING
        : undefined,
    { progress, text } = INSTANCE_COLOR_MAP.get(status)?.[recurring] || {};

  return {
    calendar_end,
    calendar_percentage,
    calendar_progress: progress,
    calendar_start,
    calendar_text: text,
    calendar_upcoming,
    calendar_upcoming_epoch,
  };
}

export function generateSignalTypeProps(instance, shadowValueBySignalIdMap) {
  const {
    GtemplateReminder: {
      recurring,
      signal_id,
      trigger_conditions: {
        signal_trigger: { interval, margin },
      },
    },
    MaintenanceHistoryLogs,
    MaintenanceNotifications,
    next_signal_value_due,
  } = instance;

  const isCompletedOneTimeReminder =
      !recurring && !!MaintenanceHistoryLogs?.length,
    signal_current = shadowValueBySignalIdMap.get(signal_id),
    signal_end = Number.parseFloat(next_signal_value_due),
    signal_next_maintenance_due_at = signal_current + interval,
    signal_start = Number.parseFloat(next_signal_value_due) - interval,
    signal_percentage = isCompletedOneTimeReminder
      ? 1
      : (signal_current - signal_start) /
        (Number.parseFloat(next_signal_value_due) - signal_start);

  let status = Array.isArray(MaintenanceNotifications)
    ? MaintenanceNotifications?.[0]?.status
    : MaintenanceNotifications?.status;
  switch (true) {
    case signal_current >= signal_end:
      status = DUE;
      break;
    case signal_current >= signal_end - Number.parseInt(margin):
      status = UPCOMING;
      break;
    case !Number.isFinite(signal_current):
    default:
      break;
  }

  const { progress, text } = INSTANCE_COLOR_MAP.get(status)?.[recurring] || {};

  return {
    signal_current,
    signal_end,
    signal_margin: margin,
    signal_next_maintenance_due_at,
    signal_percentage,
    signal_progress: progress,
    signal_start,
    signal_text: text,
  };
}

export function generateOrgReportSignalTypeProps(instance) {
  const {
    GtemplateReminder: {
      recurring,
      trigger_conditions: {
        signal_trigger: { interval, margin },
      },
    },
    MaintenanceNotifications: { MaintenanceHistoryLog } = {},
    next_signal_value_due,
    shadow_value,
  } = instance;

  const isCompletedOneTimeReminder = !recurring && !!MaintenanceHistoryLog?._id,
    signal_current = shadow_value,
    signal_end = Number.parseFloat(next_signal_value_due),
    signal_next_maintenance_due_at = signal_current + interval,
    signal_start = Number.parseFloat(next_signal_value_due) - interval,
    signal_percentage = isCompletedOneTimeReminder
      ? 1
      : (signal_current - signal_start) /
        (Number.parseFloat(next_signal_value_due) - signal_start);

  return {
    signal_current,
    signal_end,
    signal_margin: margin,
    signal_next_maintenance_due_at,
    signal_percentage,
    signal_start,
  };
}

export function getDateTriggered(instance) {
  const { MaintenanceNotifications: [{ status, updatedAt } = {}] = {} } =
    instance;

  switch (status) {
    case DUE:
    case UPCOMING:
      return format(new Date(updatedAt), 'LLLL do, y');
    case COMPLETE:
    default:
      return 'N/A';
  }
}

export function getOrgReportDateTriggered(instance) {
  const { MaintenanceNotifications: { updatedAt } = {} } = instance;

  return format(new Date(updatedAt), 'LLLL do, y');
}

export function getOrgReportServiceDetails(instance) {
  const {
    MaintenanceNotifications: {
      MaintenanceHistoryLog: { contact_info, service_date } = {},
    } = {},
  } = instance;

  const last_service_date = service_date
    ? format(new Date(service_date), 'LLLL do, y')
    : '';

  return { contact_info, last_service_date };
}

export function getOrgReportTimeTriggered(instance) {
  const { MaintenanceNotifications: { updatedAt } = {} } = instance;

  return format(new Date(updatedAt), 'h:mm aa');
}

export function getServiceDetails(instance) {
  const { MaintenanceHistoryLogs: [{ contact_info, service_date } = {}] = [] } =
    instance;

  const last_service_date = service_date
    ? format(new Date(service_date), 'LLLL do, y')
    : '';

  return { contact_info, last_service_date };
}
